module.exports = __webpack_public_path__ + "static/media/tyre-red-two2.75931d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-two2.png
// module id = 340
// module chunks = 0